import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    fullWidthContainer: {
        display: 'flex',
        justifyContent: 'end',
        width: '100%',
    },
    mobileButton: {
        width: '100%',
        display: 'flex',
    },
    addMarginTop: {
        marginTop: spacing.medium,
        [theme.breakpoints.up('sm')]: {
            marginTop: spacing.large,
        },
    },
    displayDesktop: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            marginTop: 0,
        },
    },
    displayMobile: {
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
}));
export default useStyles;
